// Apple In-App Purchases through RevenueCat (iOS app only). appUserID = our device id.
import { isNativeIOS } from "./native";
import { getDeviceId } from "./device";
import { apiClient } from "./api";

const RC_KEY = process.env.REACT_APP_REVENUECAT_IOS_PUBLIC_KEY;
let configured = null;

const purchases = async () => {
  const { Purchases } = await import("@revenuecat/purchases-capacitor");
  if (!configured) configured = Purchases.configure({ apiKey: RC_KEY, appUserID: getDeviceId() });
  await configured;
  return Purchases;
};

export const iapAvailable = isNativeIOS && !!RC_KEY;

export const syncIap = () =>
  apiClient.post("/iap/sync", { device_id: getDeviceId() }).then((r) => r.data);

const ORDER = { MONTHLY: 0, ANNUAL: 1, LIFETIME: 2 };

export const getIapPackages = async () => {
  const P = await purchases();
  const { current } = await P.getOfferings();
  return (current?.availablePackages || []).slice().sort((a, b) => (ORDER[a.packageType] ?? 9) - (ORDER[b.packageType] ?? 9));
};

// Returns true if purchased, false if the user cancelled the Apple sheet.
export const buyIapPackage = async (aPackage) => {
  const P = await purchases();
  try {
    await P.purchasePackage({ aPackage });
  } catch (e) {
    if (e?.userCancelled || e?.code === "1" || e?.code === 1) return false;
    throw e;
  }
  await syncIap();
  return true;
};

export const restoreIap = async () => {
  const P = await purchases();
  await P.restorePurchases();
  return syncIap();
};
